import t, { useState as r, useEffect as k } from "react";
import { useStripe as q, useElements as H, PaymentElement as U } from "./index6.mjs";
import W from "classnames";
import { StripeObjectType as P } from "./index17.mjs";
import { StripeButton as Y } from "./index13.mjs";
import { StripeInput as z } from "./index18.mjs";
import { getPaymentIntentStatus as G } from "./index19.mjs";
import l from "./index20.mjs";
import { TosElementWithBanner as J } from "./index14.mjs";
import { ErrorBannerContainer as h } from "./index21.mjs";
import { formatPrice as K } from "./index22.mjs";
const Q = "payment-card-name", me = ({
  stripeObjectType: C,
  country: T,
  currency: v,
  amount: _,
  onSuccess: A,
  onError: o,
  className: D,
  clientSecret: p,
  isTriggered: E,
  showSalesTerms: w,
  showTermsAndConditions: M
}) => {
  const n = q(), b = H(), [I, f] = r(!1), [N, m] = r(""), [R, g] = r(""), [a, x] = r(""), [i, F] = r(!1), [S, d] = r(!1), [B, L] = r(!1);
  k(() => {
    n && E && p && n.retrievePaymentIntent(p).then(({ paymentIntent: e }) => {
      const s = G(e);
      m(s);
    }).catch((e) => {
      o(e);
    });
  }, [o, n, E, p]);
  const u = I || !n || !b, O = S && (!a || !B), j = async (e) => {
    try {
      Rollbar == null || Rollbar.info("****** handleSubmit ******"), Rollbar == null || Rollbar.info("isDisabled: ", u), Rollbar == null || Rollbar.info("tncAccepted: ", i), Rollbar == null || Rollbar.info("cardName: ", a);
    } catch {
      console.error("Rollbar not found");
    }
    if (e.preventDefault(), d(!0), !(u || !i)) {
      if (f(!0), !a) {
        g(
          I18n.t("payment_frontend.stripe.card_name_error")
        ), f(!1);
        return;
      }
      try {
        const y = {
          [P.PAYMENT_INTENT]: n.confirmPayment,
          [P.SETUP_INTENT]: n.confirmSetup
        }[C];
        if (console.info("stripeConfirm: ", y), !y) {
          m(I18n.t("payment_frontend.unexpected_error")), o(new Error("Stripe confirm payment not found"));
          return;
        }
        const { error: c } = await y({
          elements: b,
          redirect: "if_required",
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: a,
                address: {
                  country: T
                }
              }
            }
          }
        });
        if (c) {
          if (c.type && ["validation_error", "card_error"].indexOf(c.type) !== -1) {
            o(new Error(c.message));
            return;
          }
          m(I18n.t("payment_frontend.unexpected_error"));
        } else
          console.info("**** stripeConfirm success ****"), A(i);
      } catch (s) {
        o(s);
      } finally {
        f(!1);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(
    "form",
    {
      className: W(l.stripe_form, D),
      id: "payment-form",
      onSubmit: j,
      "data-testid": "stripe-form"
    },
    /* @__PURE__ */ t.createElement(
      J,
      {
        tncAccepted: i,
        setTncAccepted: F,
        showSalesTerms: w,
        showTermsAndConditions: M,
        hasAttemptedPayment: S,
        setHasAttemptedPayment: d
      }
    ),
    /* @__PURE__ */ t.createElement("div", { className: l.form_container }, /* @__PURE__ */ t.createElement("div", { className: l.form_wrapper }, /* @__PURE__ */ t.createElement(
      z,
      {
        elementId: Q,
        errorMessage: R,
        value: a,
        onChange: (e) => {
          x(e), g("");
        }
      }
    ), /* @__PURE__ */ t.createElement(
      U,
      {
        id: "payment-element",
        className: l.payment_element,
        options: {
          layout: "auto",
          fields: {
            billingDetails: {
              name: "auto",
              address: {
                country: "never"
              }
            }
          }
        },
        onChange: (e) => {
          L(e.complete);
        }
      }
    ))),
    /* @__PURE__ */ t.createElement(
      Y,
      {
        label: I18n.t("payment_frontend.pay_now") + " " + K(_ > 0 ? _ / 100 : 0, v, !1),
        disabled: u,
        isLoading: I
      }
    ),
    N ? /* @__PURE__ */ t.createElement(
      h,
      {
        description: N,
        onDismiss: () => m("")
      }
    ) : null,
    O ? /* @__PURE__ */ t.createElement(
      h,
      {
        description: I18n.t(
          "booking_engine.errors.payment_type_empty.sub_title"
        ),
        onDismiss: () => d(!1)
      }
    ) : null
  );
};
export {
  me as StripeForm
};
